<template>
     <!-- 撤回 弹框 -->
    <el-dialog
        class="revocationDialog"
        width="80%"
        title="商品明细"
        append-to-body
        :before-close="beforeClose"
        :visible.sync="dialogVisible"
        >
        <div class="total-message">
            <span class="total">方量(m³)：{{ taskTotalVolume }}</span>
            <span class="total">重量(kg)：{{ taskTotalWeight }}</span>
            <span class="total">数量：{{taskTotalCount  }}</span>
        </div>
        <dialog-table
            ref="appointTable"
            :tableData="tableData"
            :dialogTable="inventoryDialogColumns">
        </dialog-table>
        </el-dialog>
</template>
<script>
import dialogTable from '../../../../../components/dialog/dialogTable';
import { inventoryDialogColumns } from './tableContentConfig';
import { getInventoryData } from '../../../../../api/appointmentCenter';

export default {
    components: { dialogTable },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            inventoryDialogColumns,
            tableData: []
        };
    },
    computed: {
        taskTotalVolume: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.volume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.grossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalCount = partical + (value.planQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        }

    },
    methods: {
        getData () {
            const params = {
                pageNo: 1,
                pageSize: 1000,
                taskNoList: this.rowData.taskNoList
            };
            getInventoryData(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list || [];
                }
            });
        },
        beforeClose() {
            this.$emit('update:dialogVisible', false);
        }
    },
    created () {
        this.getData();
    }
};
</script>
<style lang="less">
.total-message{
    margin-bottom: 10px;
    .total{
        margin-right: 40px;
        font-size: 14px;
    }
}

</style>
